import React from "react";
import PropTypes from "prop-types";

const Toast = props => {
  const { toastTitle, toastTitleRight, toastMessage } = props;
  console.log(
    "Inside toast: toastTitle  [",
    toastTitle,
    "] toastTitleRight  [",
    toastTitleRight,
    "] toastMessage  [",
    toastMessage,
    "]"
  );
  return (
    <div
      className="toast"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className="toast-header">
        <img src="..." className="rounded mr-2" alt="..." />
        <strong className="mr-auto">daasdasdadasdasd</strong>
        <small className="text-muted">asdasdasdaDAD</small>
        <button
          type="button"
          className="ml-2 mb-1 close"
          data-dismiss="toast"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="toast-body">This is the message</div>
    </div>
  );
};
Toast.propTypes = {
  toastTitle: PropTypes.string.isRequired,
  toastTitleRight: PropTypes.string.isRequired,
  toastMessage: PropTypes.string.isRequired
};
export default Toast;
